module.exports = __webpack_public_path__ + "static/media/roboto_regular.49ae34d4.woff";